// format number form query param
export const toNumber = (value) => {
  const number = Number(value) || 1;
  
  return isNaN(number) ? 1 : number;
};
